import { SearchPanel } from "./components/search-panel";
import { GoodsModal } from "./components/goods-modal";
import { List } from "./components/list";

import styled from "@emotion/styled";
import { useGoodsList } from "service/themeZoneGoods";
import { toNumber } from "utils";
import { useGoodsListSearchParams } from "./util";
import { useThemeZoneOptions } from "service/themeZone";

export const ThemeZoneGoodsList = () => {
  const { data: themeZoneOptions = [], error: tagOptionsError } =
    useThemeZoneOptions();
  const [params, setParams] = useGoodsListSearchParams();
  const { isLoading, error, data } = useGoodsList(params);

  return (
    <Container>
      <Main>
        <SearchPanel
          themeZoneOptions={themeZoneOptions}
          params={params}
          setParams={setParams}
        />
        <List
          themeZoneOptions={themeZoneOptions}
          params={params}
          setParams={setParams}
          error={error || tagOptionsError}
          loading={isLoading}
          dataSource={data?.list}
          pagination={{
            current: toNumber(data?.page) || 1,
            pageSize: toNumber(data?.limit),
            total: toNumber(data?.total),
            showSizeChanger: true,
          }}
          bordered
        />
      </Main>
      <GoodsModal themeZoneOptions={themeZoneOptions} />
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  height: 100%;
`;

const Main = styled.div`
  padding: 2.4rem;
  height: 100%;
  overflow: scroll;
`;
